import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=aaac8ebe&scoped=true&"
import script from "./logistics.js?vue&type=script&lang=js&"
export * from "./logistics.js?vue&type=script&lang=js&"
import style0 from "./logistics.vue?vue&type=style&index=0&id=aaac8ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaac8ebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaac8ebe')) {
      api.createRecord('aaac8ebe', component.options)
    } else {
      api.reload('aaac8ebe', component.options)
    }
    module.hot.accept("./logistics.vue?vue&type=template&id=aaac8ebe&scoped=true&", function () {
      api.rerender('aaac8ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/logistics/logistics.vue"
export default component.exports